import request from '@/utils/request'

export function getRule(query) {
    return request({
        url: '/v1/packet/rule',
        method: 'get',
        params: query
    })
}

export function getTop(query) {
    return request({
        url: '/v1/packet/top',
        method: 'get',
        params: query
    })
}

export function llRemainCount(query) {
    return request({
        url: '/v1/ll/remain-count',
        method: 'get',
        params: query
    })
}


export function getPacket(query) {
    return request({
        url: '/v1/packet/get',
        method: 'get',
        params: query
    })
}


export function getConfig(query) {
    return request({
        url: '/v1/packet/config',
        method: 'get',
        params: query
    })

}


export function getHistory(query) {
    return request({
        url: `/v1/packet/history`,
        method: 'get',
        params: query
    })
}

export function getreRemaincount(query) {
    return request({
        url: `/v1/packet/remain-count`,
        method: 'get',
        params: query
    })
}

export function getllAward(query) {
    return request({
        url: '/v1/ll/get',
        method: 'get',
        params: query
    })
}
